// src/domains/settings.keys.ts —— 模板键归属（TD-823）：原型键 9（0172 系统参数片）+ 0172 偏差块新增 12 键（M-11 / C-14；运营 UX 评审 2026-10-15 未保存提示与离开确认 +6）
export const KEYS = [
  'cfgDirty', 'cfgGroups', 'cfgMaintText', 'cfgPreviewRows', 'cfgSaving', 'cfgSettleTime', 'onMaintText', 'onSettleTime', 'saveConfig',
  'cfgErr', 'cfgWarn', 'cfgSaveTitle', 'cfgSaveStyle', 'cfgReadonly', 'cfgSettleStyle',
  'cfgDirtyBar', 'cfgDirtyBarStyle', 'cfgLeaveOpen', 'cfgLeaveText', 'cfgLeaveTitle', 'cfgLeaveStay', 'cfgLeaveGo', 'leaveStay', 'leaveGo',
] as const;
